export var providerPreLimitValues = function (merchantResponseData, provider) {
    var data = merchantResponseData.data;
    return data.preLimits.find(function (limit) { return limit.provider === provider; });
};
